import { Button, Checkbox, Modal } from 'antd';
import * as React from 'react';
import { useState } from 'react';

export interface IEulaModalProps {
	showModal: boolean;
	onCancel: () => void;
	onAccept: () => void;
	eulaVersion: number;
}

export default function EulaModal({ showModal, onCancel, onAccept, eulaVersion }: IEulaModalProps) {
	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (e: any) => {
		setIsChecked(e.target.checked);
	};

	const handleAccept = () => {
		if (isChecked) {
			onAccept();
		}
	};

	const handleCancel = () => {
		setIsChecked(false);
		onCancel();
	};

	return (
		<Modal
			open={showModal}
			footer={null}
			closable={false}
			maskClosable={false}
			width={400}
			centered
		>
			<div className="flex column items-center" style={{ padding: '1rem' }}>
				{/* Title */}
				<h2
					style={{
						color: '#232B36',
						fontSize: '1.5rem',
						fontWeight: 'bold',
						marginBottom: '1rem',
						textAlign: 'left',
					}}
				>
					Welcome to the HydroDigital Platform
				</h2>

				{/* Message */}
				<p
					style={{
						color: '#74788D',
						fontSize: '1rem',
						marginBottom: '1.5rem',
						textAlign: 'left',
					}}
				>
					We have updated our End User License Agreement.
				</p>

				{/* Checkbox */}
				<div style={{ marginBottom: '3rem', width: '100%' }}>
					<Checkbox checked={isChecked} onChange={handleCheckboxChange}>
						<span style={{ color: '#232B36' }}>
							I have read and agree to the HydroDigital Platform's{' '}
							<a
								href="https://www.hydrodigital.com/eula"
								target="_blank"
								rel="noopener noreferrer"
								style={{ color: '#078CB3', textDecoration: 'underline' }}
							>
								End User License Agreement
							</a>
							.
						</span>
					</Checkbox>
				</div>

				{/* Buttons */}
				<div className="flex" style={{ gap: '1rem', justifyContent: 'center' }}>
					<Button
						type="primary"
						disabled={!isChecked}
						style={{
							width: '120px',
							height: '40px',
							backgroundColor: isChecked ? '#00203C' : undefined,
							borderColor: isChecked ? '#00203C' : undefined,
						}}
						onClick={handleAccept}
					>
						Accept
					</Button>
					<Button
						style={{
							width: '120px',
							height: '40px',
							borderColor: '#D9D9D9',
						}}
						onClick={handleCancel}
					>
						Cancel
					</Button>
				</div>
			</div>
		</Modal>
	);
}
